<template>
  <div class="home">
    <div class="home-button">
      <button v-for="item in buttonList"
              :key="item.id"
              :class="{'home-button-active':item.id===buttonActive}"
              @click="buttonClick(item)">{{ $t(item.title) }}
      </button>
    </div>
    <div class="home-link">
      <div class="home-link-box" v-for="(contents,index) in currentContent" :key="contents.title">
        <h3>{{ $t(contents.title) }}</h3>
        <div class="home-link-box-list">
          <home-link-card v-for="(item,index1) in fliterContentList(contents.content)" :key="index+''+index1"
                          :card="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeLinkCard from './homeLinkCard.vue'
import contents from './content/contents'
import {mapGetters} from "vuex";

export default {
  name: 'home',
  components: {homeLinkCard},
  data() {
    return {
      buttonActive: 1,
      currentContent: contents.buildProdAppContent(), //当前展示内容
    }
  },
  methods: {
    buttonClick(buttonItem) {
      // console.log(JSON.stringify(buttonItem.content))
      this.buttonActive = buttonItem.id
      this.currentContent = buttonItem.content
    },
    fliterContentList(list) {
      return list.filter(item => {
        return !item.isDeveloper || this.developerChecked
      })
    }
  },
  watch: {
    developerChecked: {
      handler(val) {
        this.$nextTick(() => {
          const flag = this.buttonList.some((item) => {
            return item.id === this.buttonActive
          })
          if (!flag) { this.buttonClick(this.buttonList[0]) }
        })
      }
    }
  },
  computed: {
    // 判断是否为品沃环境
    isInPingworthNet() {
      return this.$store.state.inPingworthNet
    },
    buttonList() {
      return contents.genButtons().filter(item => {
        return !item.isDeveloper || this.$store.state.developerChecked
      });
      // return this.isInPingworthNet ? contents.genButtons()
      //   : contents.genButtons().filter(item => {
      //     return !item.isfliter
      //   })
    },
    developerChecked() {
      return this.$store.state.developerChecked
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/index.less';

.home {
  .content();
  padding: 30px 30px 95px 30px;
  box-sizing: border-box;
  margin-top: 30px;
  margin-bottom: 100px;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &-button {
    margin: 30px 0;
    position: relative;

    &-active {
      background: #FF3D48;
    }
  }

  &-link {
    position: relative;

    &-box {
      h3 {
        font-size: 24px;
        padding: 30px 0;
        margin: 0;
      }

      &-list {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}

button {
  background: #CCCCCC;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue